const obj = {
    sortByKey(arr, key) {
        const nonzero = arr.filter(item => item[key] > 0);
        const zero = arr.filter(item => item[key] === 0);
        nonzero.sort((a, b) => a[key] - b[key]);
        nonzero.forEach(item => {
            zero.splice(item[key] - 1, 0, item);
        });
        return zero;
    },

    changePositionByIdByPos(arr, id, pos) {
        const currentIndex = arr.findIndex(item => item.id === id);
        const [element] = arr.splice(currentIndex, 1);
        arr.splice(pos, 0, element);
        return arr;
    }
};

export default obj;
